export class SystemsLayer{
    constructor(data){
        this.layer = data.layer
        this.systems = data.systems
    }
}